import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGet, apiPost } from '../../api/apiclient';
import { OCR_FIELDS_EDIT_GET } from '../../api/endpoints';

// Async thunk for creating AI agents
export const getCsvDataBySlug = createAsyncThunk(
  "getCsvDataBySlug",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${OCR_FIELDS_EDIT_GET}${slug}/`);

      if (response?.data.status === "success") {
        return {
          ocr_fields: response?.data?.data?.ocr_fields,
          system_instruction: response?.data?.data?.system_instrction,
          output_instruction: response?.data?.data?.output_instruction,
          processing_options: response?.data?.data?.processing_options,
          meta_data_analyser: response?.data?.data?.meta_data_analyser
        };
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);


// Async thunk for creating AI agents
export const updateCsvDataAction = createAsyncThunk(
  "updateCsvData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiPost(`${OCR_FIELDS_EDIT_GET}${data?.slug}/`, {
        ocr_fields: data?.params,
        system_instrction: data?.systemInstruction,
        output_instruction: data?.outputInstruction,
        processing_options: data?.processingOption,
        meta_data_analyser: data?.metadataAnalyser
      });

      if (response?.data.status === "success") {
        return response?.data?.data?.message;
      } else {
        return rejectWithValue(
          response.data.message || "Unexpected error occurred."
        );
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message || "Network error occurred.");
    }
  }
);


const CSVDataSlice = createSlice({
  name: 'csv',
  initialState: {
    dataMode: null,
    csvData: [],
    systemInstruction: '',
    outputInstruction: '',
    processingOption: '',
    metadataAnalyser: false,
    getCsvError: {},
    updateCsvData: '',
    getCsvLoading: false,
    csvUpdateLoading: false
  },
  reducers: {
    setDataMode: (state, action) => {
      state.dataMode = action.payload;
    },
    setCsvData: (state, action) => {
      state.csvData = action.payload;
    },
    appendCsvData: (state, action) => {
      state.csvData = [...state.csvData, ...action.payload];
    },
    clearCsvData: (state) => {
      state.csvData = [];
    },
    clearSuccessMessage: (state) => {
      state.updateCsvData = '';
    },
    updateCsvData: (state, action) => {
      const { index, key, value } = action.payload;
      if (state.csvData[index]) {
        state.csvData[index][key] = value;
      }
    },
    updateUniqueField: (state, action) => {
      const { index } = action.payload;
      state.csvData = state.csvData.map((row, i) => ({
        ...row,
        Unique: i === index ? "1" : "",
      }));
    },
    deleteCsvRow: (state, action) => {
      const index = action.payload;
      if (index >= 0 && index < state.csvData.length) {
        state.csvData = state.csvData.filter((_, i) => i !== index);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCsvDataBySlug.pending, (state) => {
        state.getCsvLoading = true;
        state.getCsvError = null;
      })
      .addCase(getCsvDataBySlug.fulfilled, (state, action) => {
        state.getCsvLoading = false;
        state.dataMode = "upload";
        state.csvData = action.payload.ocr_fields;
        state.systemInstruction = action.payload.system_instruction || '';
        state.outputInstruction = action.payload.output_instruction || '';
        state.processingOption = action.payload.processing_options || '';
        state.metadataAnalyser = action.payload.meta_data_analyser || false;
      })
      .addCase(getCsvDataBySlug.rejected, (state, action) => {
        state.getCsvLoading = false;
        state.getCsvError = action.payload;
      })
      .addCase(updateCsvDataAction.pending, (state) => {
        state.csvUpdateLoading = true;
        state.csvUpdateError = null;
      })
      .addCase(updateCsvDataAction.fulfilled, (state, action) => {
        state.csvUpdateLoading = false;
        state.updateCsvData = action.payload;
      })
      .addCase(updateCsvDataAction.rejected, (state, action) => {
        state.csvUpdateLoading = false;
        state.csvUpdateError = action.payload;
      });
  },
});

export const { setDataMode, setCsvData, appendCsvData, clearCsvData, updateCsvData, updateUniqueField, deleteCsvRow, clearSuccessMessage } = CSVDataSlice.actions;
export default CSVDataSlice.reducer;
